export const SET_MEMBERS = 'members/SET_MEMBERS';
export const SET_FETCHING_MEMBERS = 'members/SET_FETCHING_MEMBERS';
export const SET_MEMBER_HISTORY = 'members/SET_MEMBER_HISTORY';
export const SET_OUTLIER_ANALYSIS = 'members/SET_OUTLIER_ANALYSIS';
export const SET_CONTRIBUTION_HISTORY = 'members/SET_CONTRIBUTION_HISTORY';
export const SET_MEMBER_ANALYSIS = 'members/SET_MEMBER_ANALYSIS';
export const SET_MEMBER_FILTER_RANGES = 'members/SET_MEMBER_FILTER_RANGES';
export const SET_OUTLIER_REASON_ANALYSIS = 'members/SET_OUTLIER_REASON_ANALYSIS';
export const SET_SAMPLE_MEMBER_ANALYSIS = 'members/SET_SAMPLE_MEMBER_ANALYSIS';
